<template>
  <!-- content -->
  <section id="content" class="content tvapp-cont">
    <!-- content Body -->
    <div class="content-body" v-if="loadingYn == 'N'">
      <main class="MainDev">
        <h1 class="H1Title">Discover more Apps</h1>
        <div class="search-form">
          <input
              type="text"
              autocomplete="off"
              aria-label="App Search"
              name="appSearch"
              id="appSearch"
              value=""
              class="search-check search-focus is-keyuped"
              @keyup="keyPress"
              placeholder="App Search"
              title="App Search" />
          <button type="submit" class="btn btn-search centered-r" aria-label="search" @click="goKeywordSearch()">
            <span><i class="ico ico-search2 centered-c">search</i></span>
          </button>
        </div>
        <p class="dscText">*This page does not support app detail information.</p>
        <div class="AppListWrap" v-if="appList.length > 0">
          <template v-if="pagingYn == 'N'">
            <h2 class="H2Title">All Apps</h2>
            <ul class="AppList">
              <li class="AppItem" v-for="item in appList">
                <div class="AppIcon">
                  <img :src="item.appPath" alt="" onerror="imageResize.reset(this)" />
                </div>
                <p class="AppTitle">{{ item.appName }}</p>
              </li>
            </ul>
            <div class="pagination-wrap">
              <div class="pagination">
                <div class="btn-wrap">
                  <a @click="goFirstPage()" href="javascript:;" class="btn-ico btn-page first" :class="paging.hasFirst == true ? '' : 'is-hidden'" role="button"><span><i class="ico ico-page-first">first page</i></span></a>
                  <a @click="goPrevPage()" href="javascript:;" class="btn-ico btn-page prev" :class="paging.hasPrev == true ? '' : 'is-hidden'" role="button"><span><i class="ico ico-page-prev">prev page</i></span></a>
                </div>
                <ul class="num-wrap">
                  <li v-for="page in paging.pageList">
                    <span v-show="page.num == paging.curPage" class="btn btn-num" :aria-label="page.num+'page'" aria-current="true" role="text"><span>{{ page.num }}</span></span>
                    <a v-show="page.num != paging.curPage" @click="goPage(page.num)" href="javascript:;" class="btn btn-num" :aria-label="page.num+'page'" role="button"><span>{{ page.num }}</span></a>
                  </li>
                </ul>
                <div class="btn-wrap">
                  <a @click="goNextPage()" href="javascript:;" class="btn-ico btn-page next" :class="paging.hasNext == true ? '' : 'is-hidden'" role="button"><span><i class="ico ico-page-next">next page</i></span></a>
                  <a @click="goLastPage()" href="javascript:;" class="btn-ico btn-page last" :class="paging.hasLast == true ? '' : 'is-hidden'" role="button"><span><i class="ico ico-page-last">last page</i></span></a>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="loading-wrap">
              <div class="loading"><img src="/img/cmn/loading.png" alt="loading"></div>
            </div>
          </template>
        </div>
        <div class="noData-wrap" v-else>
          <div class="noData">
            <div class="inner">
              <p><i class="ico ico-waring2" aria-hidden="true"></i><span class="noData-txt">No Posts Registered</span></p>
            </div>
          </div>
        </div>
      </main>
    </div>
    <!-- //content Body -->
    <div class="loading-wrap" v-else>
      <div class="loading"><img src="/img/cmn/loading.png" alt="loading"></div>
    </div>
  </section>
  <!-- //content -->
</template>

<script>
import qs from "qs";

export default {
  name: "AllApps",
  data() {
    return {
      appList: [],
      schTxt: "",
      loadingYn: "Y",
      pagingYn: "N",
      paging: {
        pageList: [],
        totalCount: 0,
        pageCount: 0,
        rowCount: 0,
        curPage: 1,
        hasNext: false,
        hasLast: false,
        hasPrev: false,
        hasFirst: false,
        curMaxPage: 0,
        curMinPage: 1,
        maxPage: 0
      }
    }
  },
  methods: {
    track () {
      console.log('@@@@ track:', this.$router.currentRoute.path);
      this.$ga.page(this.$router.currentRoute.path)
    },
    goFirstPage() {
      if(this.paging.curMinPage > 1) {
        this.paging.curPage = this.paging.curMinPage - 1;
      }
      this.goSearchAjax();
    },
    goPrevPage() {
      if(this.paging.curPage > 1) {
        this.paging.curPage -= 1;
      }
      this.goSearchAjax();
    },
    goNextPage() {
      if(this.paging.curPage < this.paging.maxPage) {
        this.paging.curPage += 1;
      }
      this.goSearchAjax();
    },
    goLastPage() {
      if(this.paging.curMaxPage < this.paging.maxPage) {
        this.paging.curPage = this.paging.curMaxPage + 1;
      }
      this.goSearchAjax();
    },
    goPage(page) {
      this.paging.curPage = page;
      this.goSearchAjax();
    },
    setResult(result) {
      this.paging.totalCount = result.data.totalCount;
      this.paging.pageCount = result.data.pageCount;
      this.paging.curPage = result.data.curPage;
      this.paging.rowCount = result.data.rowCount;
    },
    resetPageList() {
      var maxPage = Math.floor(this.paging.totalCount / this.paging.rowCount);
      if(this.paging.totalCount % this.paging.rowCount != 0) {
        maxPage += 1;
      }
      this.paging.maxPage = maxPage;

      this.paging.curMaxPage = Math.floor((this.paging.curPage - 1) / this.paging.pageCount) * this.paging.pageCount + this.paging.pageCount;
      this.paging.curMinPage = Math.floor((this.paging.curPage - 1) / this.paging.pageCount) * this.paging.pageCount + 1;

      this.paging.pageList = [];
      for(var i = this.paging.curMinPage; i <= this.paging.curMaxPage; ++i) {
        if(maxPage < i) {
          break;
        }
        this.paging.pageList.push({
          num: i
        });
      }

      if(maxPage <= this.paging.curMaxPage) {
        this.paging.hasLast = false;
      } else {
        this.paging.hasLast = true;
      }

      if(this.paging.curPage < maxPage) {
        this.paging.hasNext = true;
      } else {
        this.paging.hasNext = false;
      }

      if(this.paging.curPage != 1) {
        this.paging.hasPrev = true;
      } else {
        this.paging.hasPrev = false;
      }

      if(this.paging.curMinPage != 1) {
        this.paging.hasFirst = true;
      } else {
        this.paging.hasFirst = false;
      }
    },
    keyPress(e) {
      if(e.which == 13) {
        this.goKeywordSearch();
      }
    },
    goKeywordSearch() {
      const vm = this;
      vm.schTxt = $('#appSearch').val().toLowerCase();
      vm.paging.curPage = 1;
      $(window).scrollTop(0);
      vm.goSearchAjax();
    },
    goSearchAjax() {
      const vm = this;
      vm.pagingYn = "Y";
      ui.loading.open();

      const params = {
        schTxt: vm.schTxt,
        curPage: vm.paging.curPage,
        rowCount: vm.paging.rowCount,
        pageCount: vm.paging.pageCount,
        totalCount: vm.paging.totalCount
      };

      this.$axios.post("/api/tvapp/retrieveGlobalAppList.ajax",
          qs.stringify(params)).then((result) => {
        ui.loading.close();
        vm.appList = result.data.appList;
        vm.pagingYn = "N";

        vm.setResult(result);
        vm.resetPageList();

        vm.$nextTick(function() {
          ui.init();
        });
      }).catch((err) => {
        ui.loading.close();
        vm.loadingYn = "N";
        alert("error : " + err);
      });
    },
    goDetail(appId) {
      const r = { path : "/main/allapps/detail?appId=" + appId };
      this.$router.push(r);
    },
  },
  mounted() {

    const vm = this;
    vm.loadingYn = "Y";
    $(window).scrollTop(0);

    var pageCount = 10;
    var rowCount = 30;

    ui.loading.open();

    const params = {
      curPage: 1,
      rowCount: rowCount,
      pageCount: pageCount,
      totalCount: 0
    };

    this.$axios.post("/api/tvapp/retrieveGlobalAppList.ajax",
        qs.stringify(params)).then((result) => {
      ui.loading.close();
      vm.appList = result.data.appList;
      vm.loadingYn = "N";
      vm.pagingYn = "N";

      vm.setResult(result);
      vm.resetPageList();

      vm.$nextTick(function() {
        ui.init();
      });
    }).catch((err) => {
      ui.loading.close();
      vm.loadingYn = "N";
      alert("error : " + err);
    });

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.wrap {
  width: 100%;
  height: 100vh;
  /* background-color: blue; */
  padding-top: 10.5rem;
  margin: 0;
}
.MainDev {
  height: calc(100%- 9.8rem);
  /* background-color: red; */
  padding: 3.125vw 15vw;
}
.H1Title {
  font-size: clamp(3.5rem, 5vw, 4.4rem);
  font-weight: 700;
  text-align: center;
  letter-spacing: -0.34px;
  margin-bottom: 5rem;
}
.search-form {
  position: relative;
  max-width: 90rem;
  margin: 0 auto;
  width: 90%;
}
.AppListWrap {
  margin-top: 5rem;
  width: 100%;
  max-width: 150rem;
  margin: 5rem auto 0rem auto;
}
.H2Title {
  color: #666666;
  font-size: 2.2rem;
  font-weight: 500;
}
/* 20260121 수정 김수빈k */
ul.AppList {
  margin-top: 3rem;
  margin-bottom: 3rem;
  width: 100%;
  /* display: grid; */
  gap: 2.2rem 2.2rem;
  flex-wrap: wrap;
  align-items: center;
  /* grid-template-columns: repeat(auto-fill, minmax(115px, 1fr)); */
  display: flex;
  justify-content: center;
}
li.AppItem {
  width: calc(100% / 10 - 2rem);
}
.AppIcon {
  width: 100%;
  aspect-ratio: 1/1;
  border-radius: calc(100% / 5);
  border: 1px solid #e4e4e4;
  font-size: 0;
  margin-bottom: 1.6rem;
  overflow: hidden;
}
.AppIcon > img {
  width: 100%;
}
.AppTitle {
  font-size: 1.6rem;
  color: #333;
  text-align: center;
  width: 100%;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  line-height: 2rem;
  height: 4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}
.FooterDev {
  /* background-color: aqua; */
  border-top: 1px solid #d4d4d4;
  background-color: #f8f8f8;
  padding: 1.56vw 4.68vw;
  text-align: right;
}
.dscText {
  font-size: 1.2rem;
  text-align: center;
  color: #666666;
  margin-top: 1.2rem;
}

.FooterDev > p {
  font-size: clamp(1rem, calc((100vw / 1920) * 12), 1.2rem);
  color: #9c9c9c;
}
.num-wrap .dv-pc-only {
  display: block !important;
}
@media (min-width: 701px) and (max-width: 1400px) {
  li.AppItem {
    width: calc(100% / 6 - 2rem);
  }
}
@media (min-width: 0px) and (max-width: 700px) {
  .MainDev {
    height: calc(100%- 9.8rem);
    /* background-color: red; */
    padding: 3.125vw 5vw;
  }
  ul.AppList {
    margin-top: 3rem;
    margin-bottom: 3rem;
    width: 100%;
    display: flex;
    gap: 2rem 1.5rem;
    flex-wrap: wrap;
    align-items: center;
  }
  li.AppItem {
    flex: 0 0 calc((100% - 3 * 1.1rem) / 3);
    min-width: 8rem;
  }
  .num-wrap .dv-pc-only {
    display: none !important;
  }
}
/* 20260121 수정 김수빈k */
</style>
